import { defineMessages } from 'react-intl';

export default defineMessages({
    duplicatePaymentDetectedTitle: {
        id: 'twia.duplicatePayment.Duplicate Payment Detected',
        defaultMessage: 'Duplicate Payment Detected'
    },
    duplicatePaymentDetectedBody: {
        id:'twia.duplicatePayment.Duplicate Payment Detected Body',
        defaultMessage: 'A payment for this amount ({amountx}) was processed on {datex}. Do you wish to continue with this payment?'
    },
    duplicatePaymentContinue:{
        id: 'twia.duplicatePayment.Duplicate Payment Continue',
        defaultMessage: 'Continue'
    },
    duplicatePaymentCancel: {
        id: 'twia.duplicatePayment.Duplicate Payment Cancel',
        defaultMessage: 'Cancel'
    }
});